// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.process.ProcessResults
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class ProcessResults {
  static createProcessResults(exitCode, stdErr, stdOut) {
    const retVal = new ProcessResults();
    retVal.initProcessResults(exitCode, stdErr, stdOut);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createProcessResults factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadp.ProcessResults";
  }
  initFromJson(json, deserializeContext) {
    this.initProcessResults(json.exitCode, json.stdErr != null ? json.stdErr : null, json.stdOut != null ? json.stdOut : null);
  }
  initProcessResults(exitCode, stdErr, stdOut) {
    this._exitCode = exitCode;
    this._stdErr = stdErr;
    this._stdOut = stdOut;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["exitCode"] = this._exitCode;
    retVal["stdErr"] = this._stdErr;
    retVal["stdOut"] = this._stdOut;
    return retVal;
  }
  get exitCode() {
    return this._exitCode;
  }
  set exitCode(value) {
    this._exitCode = value;
  }
  get stdErr() {
    return this._stdErr;
  }
  set stdErr(value) {
    this._stdErr = value;
  }
  get stdOut() {
    return this._stdOut;
  }
  set stdOut(value) {
    this._stdOut = value;
  }
}
//# sourceMappingURL=ProcessResults.js.map
